import React from 'react';
import {string} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {WinnerStatus as WinnerStatusEnum} from 'utils/DBUtils';

const WinnerStatus = ({status}) => status in WinnerStatusEnum && (
  <div className={`winner-status ${status}`}>
    <FormattedMessage id={`winnersList.column.status.enum.${status}`} />
  </div>
);

WinnerStatus.propTypes = {
  status: string
};

export default WinnerStatus;



// WEBPACK FOOTER //
// ./public/components/prizes/WinnerStatus.jsx